<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="courseTip"
      label-position="right"
      label-width="150px"
      class="form"
    >
      <el-form-item label="模板名称" prop="title">
        <el-input
          v-model="courseTip.title"
          maxlength="14"
          show-word-limit
          clearable
          placeholder="请输入课卡名称"
        />
      </el-form-item>

      <el-form-item label="模板内容" prop="tip">
        <el-input
          type="textarea"
          :autosize="{ minRows: 10, maxRows: 20}"
          v-model="courseTip.tip"
          maxlength="2000"
          show-word-limit
        />
      </el-form-item>

      <el-form-item label="课卡预约退课须知" prop="cancel_tip_card">
        <el-input
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 20}"
          v-model="courseTip.cancel_tip_card"
          maxlength="140"
          show-word-limit
        />
      </el-form-item>

      <el-form-item label="微信支付退课须知" prop="cancel_tip_we_chat_pay">
        <el-input
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 20}"
          v-model="courseTip.cancel_tip_we_chat_pay"
          maxlength="140"
          show-word-limit
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">保存修改</el-button>
        <el-button @click="RouteConfig.courseTipList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { show, update } from '@/api/course-tip';

export default {
  name: RouteConfig.courseTipEdit.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    courseTip: {
      title: '',
      tip: '',
      update_time: 0,
      cancel_tip_card: '',
      cancel_tip_we_chat_pay: '',
    },
    rules: {
      title: [{ required: true, message: '请输入模板名称', trigger: 'change' }],
      tip: [{ required: true, message: '请输入模板内容', trigger: 'change' }],
      cancel_tip_card: [{ required: true, message: '请输入课卡预约退课须知', trigger: 'change' }],
      cancel_tip_we_chat_pay: [{ required: true, message: '请输入微信支付退课须知', trigger: 'change' }],
    },
  }),
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const { isError } = await update(this.id, this.courseTip);
        this.isSaving = false;
        if (!isError) RouteConfig.courseTipList.back();
      });
    },
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      const { courseTip } = this;
      const courseTipInfo = {};
      Object.keys(data).forEach(key => {
        if (key in courseTip) courseTipInfo[key] = data[key];
      });
      Object.assign(courseTip, courseTipInfo);
    },
  },
};
</script>
